import {useEffect} from 'react';
import {Link, Route} from 'react-router-dom';

import {InvoiceService} from '../service/InvoiceService';

import {TraCuu} from './tra-cuu';

const invoiceService = new InvoiceService();

export const App = () => {

	useEffect(() => {
		invoiceService.getIntroduction().then(data => {
			if (data?.description?.trim()) {
				// setDisplayAds(data.description);
			}
		}).catch(() => {
		});
	}, []);

	return (
		<div className="App">
			<div className="layout-topbar">
				<div className="flex align-items-center justify-content-between">
					<Link to="/" className="layout-topbar-logo">
						<img src={'/assets/sun-invoice/sun_invoice_logo.png'} alt="SUN Invoice"/>
					</Link>
					<ul className="iam-topbar-actions">
						<li className="iam-topbar-action">
							<a className="p-d-flex p-flex-row p-ai-center" href="https://zalo.me/3031388339749459019" rel="noreferrer" target="_blank" title="Hỗ trợ trực tiếp">
								<img src="/assets/images/zalo-60x60.png" alt="" width="30" style={{marginRight: '0.5rem'}}/>
								<span>Hỗ trợ trực tiếp</span>
							</a>
						</li>
					</ul>
				</div>
			</div>

			<div>
				<Route path="/" exact component={TraCuu}/>
			</div>

			<div className="layout-footer text-center text-white p-5">
				<b>CÔNG TY CỔ PHẦN SUN-INVOICE VIỆT NAM</b>
				<p><i className="pi pi-map-marker mr-2"/>Sàn 2902, Tòa nhà Văn phòng Rox Tower, Số 136 Hồ Tùng Mậu, Phường Phú Diễn, TP Hà Nội, Việt Nam</p>
				<p><i className="pi pi-phone mr-2"/><b>Hotline:</b> 1900 0262</p>
			</div>
		</div>
	);
}
